<template>

    <div class="#">

        <ul class="nav nav-tabs d-noneX" id="productTab" role="tablist">
            <li class="nav-item pointer">
                <a v-on:click="tab1Fn()" v-bind:class="'nav-link '+tab1Active" id="tab1-tab" data-toggle="tab" role="tab" aria-controls="tab1" aria-selected="true">{{$t('productTabs.sellAsCategory')}}</a>
            </li>
            <li class="nav-item pointer">
                <a v-on:click="tab2Fn()" v-bind:class="'nav-link '+tab2Active" id="tab2-tab" data-toggle="tab" role="tab" aria-controls="tab2" aria-selected="false">{{$t('productTabs.sellBarcodeAndName')}}</a>
            </li>
            <!--<li class="nav-item pointer">-->
                <!--<a v-on:click="tab3Fn()" v-bind:class="'nav-link '+tab3Active" id="tab3-tab" data-toggle="tab"  role="tab" aria-controls="tab3" aria-selected="false">Tallózás</a>-->
            <!--</li>-->
        </ul>
        <div class="tab-content pt-2 pl-1" id="productTabContent">
            <div v-bind:class="'tab-pane fade '+tab1Active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">

                <ProductSearcherMass></ProductSearcherMass>

            </div>
            <div v-bind:class="'tab-pane fade '+tab2Active" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">
                <ProductSearcherByNameBarcode></ProductSearcherByNameBarcode>

            </div>
            <!--<div v-bind:class="'tab-pane fade '+tab3Active" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">-->
                <!--33333333333333333-->
            <!--</div>-->
        </div>
    </div>

</template>


<script>
    import Helper from '@/helper/Helper';
    import ProductSearcherMass from "./ProductSearcherMass";
    import ProductSearcherByNameBarcode from "./ProductSearcherByNameBarcode";

    export default {
        name: 'ProductTabs',
//        roles: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
        mounted() {
            const modul = this;
            modul.tab1Fn()
        },
        data() {
            return {
                tab1: true
                , tab2: false
                , tab3: false
                , tab4: false
                , tab1Active: ""
                , tab2Active: ""
                , tab3Active: ""
                , tab4Active: ""
            };
        },
        methods: {
            makeTabClasses(){
                const modul = this;
                const className = " active show ";
                if (modul.tab1) {
                    modul.tab1Active = className
                } else {
                    modul.tab1Active = ""
                }
                if (modul.tab2) {
                    modul.tab2Active = className
                } else {
                    modul.tab2Active = ""
                }
                if (modul.tab3) {
                    modul.tab3Active = className
                } else {
                    modul.tab3Active = ""
                }
                if (modul.tab4) {
                    modul.tab4Active = className
                } else {
                    modul.tab4Active = ""
                }
            },
            tab1Fn(){
                const modul = this;
                modul.tab1 = true;
                modul.tab2 = false;
                modul.tab3 = false;
                modul.tab4 = false;
                modul.makeTabClasses();
            },
            tab2Fn(){
                const modul = this;
                modul.tab1 = false;
                modul.tab2 = true;
                modul.tab3 = false;
                modul.tab4 = false;
                modul.makeTabClasses();
            },
            tab3Fn(){
                const modul = this;
                modul.tab1 = false;
                modul.tab2 = false;
                modul.tab3 = true;
                modul.tab4 = false;
                modul.makeTabClasses();
            },
            tab4Fn(){
                const modul = this;
                modul.tab1 = false;
                modul.tab2 = false;
                modul.tab3 = false;
                modul.tab4 = true;
                modul.makeTabClasses();
            }
        },
        components: {
            ProductSearcherMass,
            ProductSearcherByNameBarcode,
        },
    };
</script>
